// react and js
import { React } from "react";
import { BrowserRouter, } from "react-router-dom";
import Routing from "./routes";

// mui

// components

// hooks
import useAffiliateTracking from "./hooks/useAffiliateTracking";

// layouts

// pages

// theme
import ThemeProvider from "./theme/ThemeProvider";

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function App() {
  // Affiliate tracking 
  useAffiliateTracking();
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Routing />
      </ThemeProvider>
    </BrowserRouter>
  );
}
